import { dedupe } from 'Helpers/Array';

export function getRange(items, selectedItems, selectTarget, selectDirection) {
    let lastSelectedItem = null;
    let itemsToSelect = [];
    let lastItemToSelect = null;

    //Set selection direction
    items.forEach((item, index) => {
        const selectedIndex = selectedItems.findIndex(selectedItem => selectedItem.id === item.id);

        //Find last selected item
        if (selectedIndex !== -1) {
            lastSelectedItem = item.id;
        }

        //Find selection target
        if (item.id === selectTarget.id) {
            lastItemToSelect = item.id;

            //Add selection target to selection
            selectedItems.push(item);
        }

        // Set selection target
        if (lastSelectedItem && !lastItemToSelect) {
            selectDirection = 'ltr';
        } else if (!lastSelectedItem && lastItemToSelect) {
            selectDirection = 'rtl';
        }

        if (selectDirection === 'ltr') {
            //Select item if loop above last selected and below selection target
            if (lastSelectedItem && !lastItemToSelect) {
                selectedItems.push(item);
            }

            //Remove selected items above selection target
            if (lastItemToSelect && item.id !== lastItemToSelect && selectedIndex !== -1) {
                selectedItems.splice(selectedIndex, 1);
            }
        } else if (selectDirection === 'rtl') {
            //Select item if loop below last selected and above selection target
            if (!lastSelectedItem && lastItemToSelect) {
                selectedItems.push(item);
            }

            //Remove selected items below selection target
            if (!lastItemToSelect && selectedIndex !== -1) {
                selectedItems.splice(selectedIndex, 1);
            }
        }
    });

    //Dedupe selected items
    selectedItems = dedupe(selectedItems, 'id');

    return {
        selectDirection: selectDirection,
        selectedItems: selectedItems
    };
}



// WEBPACK FOOTER //
// ./src/helpers/Select.js